module.exports = __webpack_public_path__ + "static/media/Bird8.01f26583.jpg";